<script setup lang="ts">
import { RouteLocationRaw } from "vue-router";

import { useFeatureFlag } from "@/composables/feature-flag/use-feature-flag";
import { V4HSiteId } from "@/data/common/ids";
import { useTypedIntl } from "@/locales/typed-intl";
import { ERouteName } from "@/router/router.type";
import { siteDefaultProgramFeatureFlag } from "@/services/feature-flags/env-feature-flags";
import { EMixpanelEvent } from "@/services/mixpanel/mixpanel-events.type";
import { MixpanelService } from "@/services/mixpanel/mixpanel-service";

import ConsumptionOverviewSitesDataTable from "@/components/data/table/consumption-overview-sites-data-table.vue";
import BaseLayout from "@/components/layout/base-layout.vue";

const { t, k } = useTypedIntl();

const { isEnvFeatureEnabled } = useFeatureFlag();

function handleSearchUsed() {
  MixpanelService.trackEvent(EMixpanelEvent.PROGRAM_SITE_SEARCH_PERFORMED);
}

function tableRowRouterLinkPath(siteId: V4HSiteId): RouteLocationRaw {
  return {
    name: isEnvFeatureEnabled(siteDefaultProgramFeatureFlag)
      ? ERouteName.PROGRAMMING_LIST_NEW
      : ERouteName.PROGRAMMING_LIST,
    params: { siteId },
  };
}
</script>

<template>
  <BaseLayout
    :subtitle="t(k.control.programming.subtitle)"
    :title="t(k.control.programming.title)"
  >
    <ConsumptionOverviewSitesDataTable
      auto-select-single-site
      :router-link-to="tableRowRouterLinkPath"
      search-input-data-test-id="programming-sites-search-input"
      @search-used="handleSearchUsed"
    />
  </BaseLayout>
</template>
